// removed by extract-text-webpack-plugin
module.exports = {"agentInfo":"uh3JM32v_0mO3YWzZnRvG","noSelectedAgent":"_2JsYu8COT6qweAeQI5cYI3","agent":"xW90Nucd7S02J-TMOX6dV","general":"_1hqwzMiurzFMP7H51U2SQl","mainInfo":"_2PdvUPajungSugZ9EKKtjc","mainInfoItem":"_1AY3dbQOgRISoLQqhjTZFL","name":"_1u5esLjdQdyHE5DlGIi7tX _1AY3dbQOgRISoLQqhjTZFL","nameInputBox":"rucOnyCP-z-TwCKvwy1EL","status":"_2iv8zHpJ4LAouU7KFX8LeM _1AY3dbQOgRISoLQqhjTZFL","statusSelection":"_1Fjv3PPq1vM4A056kz1z6a","deleteIcon":"_27wpx8hv3g2Yz_UIE1bm_I","tasksHeader":"_9OU3con-tRLGCZSae7mti","addIcon":"_306s80YOpp_WgUAkDdBz4x"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AgentInfo/style.css
// module id = 389
// module chunks = 0